import React, { Component } from 'react';
import logo from './assets/logo.svg';
import './App.css';

import TextInput from './components/textInput';

import SignatureOutput from './components/signatureOutput';

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: 'Max Mustermann',
			email: 'maxmuster@freeatheart.de',
			phone: '+49 157 6543210'
		}
		this._handleInputChange = this._handleInputChange.bind(this);
	}

	_handleInputChange(event) {
		const target = event.target;
		const value = target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	render() {
		return (
			<div className="App">
				<header className="App-header">
					<img src={logo} className="App-logo" alt="logo" />
					<h1 className="App-title">Signaturgenerator</h1>
				</header>
				<div className="container">
					<div className="col-1-2">
						<div className="App-form shadowbox">
							<h2>Deine Signaturdaten</h2>
							<form className="form">
								<TextInput
									label={'Vor- und Nachname'}
									name={'name'}
									onChange={this._handleInputChange}
									placeholder={this.state.name} />
								<TextInput
									label={'E-Mail Adresse'}
									name={'email'}
									onChange={this._handleInputChange}
									placeholder={this.state.email} />
								<TextInput
									label={'Telefon'}
									name={'phone'}
									onChange={this._handleInputChange}
									placeholder={this.state.phone} />
							</form>

						</div>
					</div>
					<div className="col-1-2">
						<SignatureOutput
							name={this.state.name}
							email={this.state.email}
							phone={this.state.phone} />
					</div>
				</div>
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js